import { render, staticRenderFns } from "./addOrEditAlbum.vue?vue&type=template&id=68d1a7db&scoped=true"
import script from "./addOrEditAlbum.vue?vue&type=script&lang=js"
export * from "./addOrEditAlbum.vue?vue&type=script&lang=js"
import style0 from "./addOrEditAlbum.vue?vue&type=style&index=0&id=68d1a7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1a7db",
  null
  
)

export default component.exports